import Alpine from 'alpinejs';

document.addEventListener('alpine:init', () => {
    Alpine.directive('skeleton', (el, { expression }, { effect, evaluateLater }) => {
        // 1. Check if the expression is a numeric width multiplier
        const hasCustomWidth = expression && !isNaN(expression);

        // 2. Find the data source:
        // Priority: If expression is NOT a number, use it.
        // Otherwise, check x-text, then check x-html.
        const sourceAttribute = el.getAttribute('x-text') || el.getAttribute('x-html');
        const targetExpression = hasCustomWidth ? sourceAttribute : (expression || sourceAttribute);

        // 3. Apply the width to a CSS variable (default to 3 if none provided)
        const widthMultiplier = hasCustomWidth ? expression : 3;
        el.style.setProperty('--skeleton-width', `${widthMultiplier}em`);

        if (!targetExpression) return;

        const getValue = evaluateLater(targetExpression);
        const isUserStore = sourceAttribute && sourceAttribute.includes('$store.user.');

        effect(() => {
            getValue(value => {
                const isEmpty = value == null || value === '' || (typeof value === 'string' && value.trim() === '');

                if (isUserStore && Alpine.store('user')?.isFetched) {
                    el.classList.add('is-ready');
                    if (isEmpty) {
                        Alpine.nextTick(() => { el.textContent = 'n/a'; });
                    }
                } else if (isEmpty) {
                    el.classList.remove('is-ready');
                } else {
                    el.classList.add('is-ready');
                }
            })
        })
    });
});
